
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/main-series/pre-upsc",
      function () {
        return require("private-next-pages/main-series/pre-upsc.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/main-series/pre-upsc"])
      });
    }
  